module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"message":"Привет","welcome":"Willkommen!","yes-button":"Ja","no-button":"Nein!"},"uz":{"hello":"Hello i18n in SFC!","welcome":"Welcome!","yes-button":"Yes","no-button":"No!"}}')
  delete Component.options._Ctor
}
